import type { ReactNode } from "react"

export const AuthSplitLayout = ({
  children,
  sidebar,
}: {
  children: ReactNode
  sidebar: ReactNode
}) => {
  return (
    <section className="bg-secondary relative flex min-h-screen items-start justify-center overflow-hidden px-4 py-12 md:items-center md:px-8">
      {/* Subtle brand glow over the neutral off-white canvas — a hint of Batyr atmosphere, not a wash of colour */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-1 hidden lg:block"
        style={{
          background:
            "radial-gradient(circle at 18% 0%, color-mix(in oklab, var(--color-batyr-yellow) 10%, transparent), transparent 55%), radial-gradient(circle at 0% 100%, color-mix(in oklab, var(--color-batyr-mint) 8%, transparent), transparent 50%)",
        }}
      />
      {/* One centered cluster: the form and the sidebar travel together so the
          rest of the viewport reads as whitespace. `relative` makes the pair
          the anchor for the decorative doodles (rendered inside `children`),
          so they frame the group; overflow is clipped on the section so the
          frame can bleed past the cluster without forcing horizontal scroll. */}
      <div className="relative z-10 flex w-full max-w-4xl items-center justify-center gap-12 xl:gap-16">
        <div className="flex w-full flex-col gap-8 sm:max-w-96">{children}</div>
        {/* Supporting act: the carousel sits as a calm, contained panel beside
            the form — not a full-height block that competes with it. */}
        <div className="hidden h-[70vh] max-h-[640px] w-full max-w-md lg:block">
          {sidebar}
        </div>
      </div>
    </section>
  )
}
